import { cx } from '@linaria/core'
import { memo } from 'react'
import { locales } from '../../../locales/en'
import Button from '../../Buttons/Button'
import { refreshStyles, reload, rootStyles, verificationStyles } from './shared'

const SignupVerified = memo(() => (
    <div className={rootStyles}>
        <h4 className={'typography gutter-bottom centered'}>
            {locales.signup.thankYouForVerifying}
        </h4>
        <div className={cx('centered', verificationStyles)}>
            {locales.signup.refreshToContinue}
        </div>
        <Button onClick={reload} size="medium" className={refreshStyles}>
            {locales.signup.refresh}
        </Button>
    </div>
))

export default SignupVerified
